interface Category {
  slug: string
  name: string
}

interface CombinedCategory extends Category {
  isPositive: boolean
}

function combineCategories(
  categories: Category[] = [],
  negativeCategories: Category[] = [],
): CombinedCategory[] {
  const combined: CombinedCategory[] = []
  for (const category of categories) {
    combined.push({
      slug: category.slug,
      name: category.name,
      isPositive: true,
    })
  }
  for (const category of negativeCategories) {
    combined.push({
      slug: category.slug,
      name: category.name,
      isPositive: false,
    })
  }
  return combined
}

export { combineCategories }
